import React from 'react';
import { Input } from 'antd';

export interface IFormTextInput {
	label: string;
	value?: string;
	onChange: (value: string) => void;
}

const FormTextInput = ({ label, value, onChange, ...inputProps } : IFormTextInput) => {
	return (
		<>
			<div style={{ gridColumn: 1 }}>
				<strong>{label}:</strong>
			</div>
			<div style={{ gridColumn: '2/6' }}>
				<Input onChange={e => onChange(e.target.value)} value={value} />
			</div>
		</>
	);
};
export default FormTextInput;
